import type { Store } from 'react-sweet-state';

import { createChatStore } from '@atlassian/conversation-assistant-store/controllers/chat';
import type { ChatStorePrivateState } from '@atlassian/conversation-assistant-store/controllers/chat/types';

import { actions } from './actions';

export const chatStore: Store<ChatStorePrivateState, typeof actions> = createChatStore(actions);
